import { FC } from "react";
import { StyledNavItemLink } from "../../NestedNavbar.styles";
import { isInternalNavLink, navLink } from "types/CMS/Unum/Navbar/navLink";
import { navItem } from "types/CMS/Unum/Navbar/navbar";
import Icon from "../../../../CMSEnabled/Icon/Icon";

type navLinkProps = {
  item: navLink;
  onClick: (
    e: React.MouseEvent<HTMLElement, MouseEvent>,
    navItem: navItem
  ) => void;
  activeLink?: string;
};

const NavLink: FC<navLinkProps> = ({ item, onClick, activeLink }) => {
  const { id, icon, label, depth = 0 } = item;
  const onNavbarClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();
    onClick(e, item);
  };
  return (
    <li key={id}>
      <StyledNavItemLink
        tabIndex={0}
        href={`${item.link}`}
        onClick={onNavbarClick}
        $isActive={activeLink === item.link}
      >
        {depth <= 0 && icon && <Icon name={icon} width={20} height={20} />}
        <span>{label}</span>
        {!isInternalNavLink(item) && (
          <Icon name="LinkExternal01" width={16} height={16} />
        )}
      </StyledNavItemLink>
    </li>
  );
};

export default NavLink;
